exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#stamp-active-release-container .block-chosen-type-active {padding: 0 1.0715rem;}\n#stamp-active-release-container #stamp-active-date-exp {z-index: 0;}\n\n#stamp-active-message {display: none}\n\n.block-chosen-type-active .radio-custom label {padding-left: 30px}\n.block-chosen-type-active .radio-custom label:before {margin-left: 0}\n.block-chosen-type-active .radio-custom label:after {margin-left: 0}\n\n#stamp-active-release-container .input-daterange div.input-group {width: 100%}\n\n/*log active release*/\n.fix-header{display: block}\n.panigation-page {float: right; margin-top: 10px;}\n\n/*fix vcd*/\n#block-insert-stamp-order label {padding-left: 0}\n#block-insert-stamp-order label:before, #block-insert-stamp-order label:after {visibility: hidden}\n\n\n.table-show-data-block select.form-control:not([size]):not([multiple]) {height: calc(2rem + 2px) !important;}\n.table-show-data-block select.form-control{line-height: 1 !important;}\n.table-show-data-block .form-control{height: 2rem !important;}\n\n#inputStart, #inputEnd{z-index: 0}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/evs/stamp/style.css
// module id = ../../../../../src/app/pages/admin/evs/stamp/style.css
// module chunks = 3